/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Swiper, SwiperSlide } from 'swiper/react';
import { isEmpty } from 'lodash';
import ReactPaginate from 'react-paginate';
import {
  OurAwardsWrapper,
  OurAwardsWrapperHeading,
  OurAwardsBody,
  OurAwardsSlider,
  OurAwardsLogo,
  OurAwardDescription,
  OurAwardsPagination,
  SliderContenSection,
  OurAwardsTab,
  OurAwardsDesktopWrapper,
  SliderContentWrapper,
  SliderPrevButton,
  SliderNextButton,
} from '../styles/OurAwards.styled';
import Sprites from '../Sprites';

export default function AwardsDesktop({ data, dir }) {

  const { title, awardsList } = data;
  const [currIndex, setCurrIndex] = useState(0);
  const [swiper, setSwiper] = React.useState(null);
  const [initialSlide, setInitialSlide] = React.useState(0);

  const slideNext = () => {
    swiper.slideNext();
  };

  const slidePrev = () => {
    swiper.slidePrev();
  };
  const currContent = awardsList[currIndex]?.content || {};
  const breakpoints = {
    0: {
      slidesPerView: 1.2,
      centeredSlides: false,
    },
    320: {
      slidesPerView: 1.5,
      centeredSlides: false,
    },
    557: {
      slidesPerView: 2.2,
      centeredSlides: false,
    },
    768: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    1280: {
      slidesPerView: 4,
      centeredSlides: false,
    },
  };

  return (
    <OurAwardsDesktopWrapper>
      <OurAwardsWrapperHeading dir={dir}>{title}</OurAwardsWrapperHeading>
      <OurAwardsBody dir={dir}>
        <div className='swiper-header-section'>
          <div className="swiper-section">
            <Swiper
              breakpoints={breakpoints}
              loop
              onSwiper={setSwiper}
              initialSlide={initialSlide}
              spaceBetween={0}
              slideToClickedSlide
              onClick={(_swiper) => setCurrIndex(_swiper.realIndex)}
              onSlideChange={(_swiper) => setCurrIndex(_swiper.realIndex)}
              pagination={{ clickable: true }}
            >
              {isEmpty(awardsList) ||
                awardsList.map((item, index) => (
                  <SwiperSlide key={index}>
                    <OurAwardsSlider className="slide">
                      <OurAwardsTab>{item.content.title}</OurAwardsTab>
                    </OurAwardsSlider>
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>

          <SliderPrevButton onClick={slidePrev}>
            <Sprites name="arrowprev" />
          </SliderPrevButton>
          <SliderNextButton onClick={slideNext}>
            <Sprites name="arrownext" />
          </SliderNextButton>
        </div>

        {isEmpty(currContent) || (
          <SliderContenSection>
            <div className="seperator" />
            <SliderContentWrapper >
              <h3>{currContent.header}</h3>
              <OurAwardDescription>{parse(currContent.bulletList)}</OurAwardDescription>
            </SliderContentWrapper>
          </SliderContenSection>
        )}
      </OurAwardsBody>
    </OurAwardsDesktopWrapper>
  );
}
